import * as React from 'react';

import { useRefreshToken } from 'hooks';

// NOTE: only use on RouterProvider childrens
const RefreshTokenProvider = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  useRefreshToken();
  return <React.Fragment>{children}</React.Fragment>;
};

export { RefreshTokenProvider };
